/* Version Drawer */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.product_drawer_open');
    if (!trigger) return;

    const popupClass = trigger.getAttribute('popup_id');
    if (!popupClass) return;

    // close any open popup first
    document.querySelectorAll('.Included_maindrawer_new.open')
      .forEach(el => el.classList.remove('open'));

    const target = document.querySelector(`.Included_maindrawer_new.${popupClass}`);
    if (!target) return;

    target.classList.add('open');
    document.body.classList.add('product_drawer_is_open');
  });

  document.addEventListener('click', function (e) {
    const closeTrigger = e.target.closest('.product_drawer_overlay_new, .product_drawer_close');
    if (!closeTrigger) return;

    document.body.classList.remove('product_drawer_is_open');

    document.querySelectorAll('.Included_maindrawer_new.open')
      .forEach(el => el.classList.remove('open'));
  });
/* Version Drawer */